import template from './reassignFundingLineModal.html';
import controller from './reassignFundingLineModal.controller';

let ReassignFundingLineModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

ReassignFundingLineModalComponent.template = template;
ReassignFundingLineModalComponent.controller = controller;

export default ReassignFundingLineModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/reassignFundingLineModal/reassignFundingLineModal.component.js